import { UseQueryOptions, UseQueryResult, useQuery } from '@tanstack/react-query';

import { z } from 'zod';

import {
  GetTkv2OrderAPIError,
  GetTkv2OrderAPIVariables,
  fetchGetTkv2OrderAPI,
} from '../toolkitComponents.js';
import { queryKeyFn, useToolkitContext } from '../toolkitContext.js';
import { Registry } from './registry.js';

type Response = z.infer<typeof schema>;
const { schema } = Registry.getTkv2OrderAPI;

export function useGetTkv2OrderAPI(
  variables: GetTkv2OrderAPIVariables,
  opts?: UseQueryOptions<Response, GetTkv2OrderAPIError>,
): UseQueryResult<Response> {
  const { fetcherOptions } = useToolkitContext();

  return useQuery<Response, GetTkv2OrderAPIError>(
    queryKeyFn({
      path: '/api/v2/orders/{orderID}',
      operationId: 'getTkv2OrderAPI',
      variables,
    }),
    async () => {
      const res = await fetchGetTkv2OrderAPI({ ...fetcherOptions, ...variables });
      return schema.parse(res);
    },
    opts,
  );
}
